import { ShouldNotHappen } from 'utils';

import {
  BrancheDto,
  BrancheDtoBrancheEnum,
  BrancheRequestDto,
  BrancheRequestDtoBrancheEnum,
  ReferenceDtoBrancheDto,
} from 'lib_api/lib/api/gen';

import { FetchDataResult } from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';

import { BrancheFormValue } from './type';

export function useFetchBranches(): [
  () => Promise<ReferenceDtoBrancheDto>,
  (result: ReferenceDtoBrancheDto) => FetchDataResult<BrancheDto>,
] {
  const controller = useApi().ReferentielControllerApi;

  return [
    () => controller.getAllValidNaturesUsingGET(),
    result => {
      const { referenceDtoList: branchesDto } = result;

      // Trier systématiquement par branche puis par nature
      branchesDto.sort(
        (a, b) =>
          (a.branche || '').localeCompare(b.branche || '') ||
          (a.nature || '').localeCompare(b.nature || ''),
      );

      return {
        total: branchesDto.length,
        data: branchesDto,
      };
    },
  ];
}

export function buildDto(values: BrancheFormValue): BrancheRequestDto {
  return {
    branche: values.branche || null,
    nature: values.nature || null,
  };
}

export function buildDefaultUpdateFormValues(
  branche: BrancheDto,
): BrancheFormValue {
  return {
    nature: branche.nature,
    branche: mapBrancheDtoBrancheEnumToBrancheRequestDtoBrancheEnum(
      branche.branche,
    ),
  };
}

function mapBrancheDtoBrancheEnumToBrancheRequestDtoBrancheEnum(
  value: BrancheDtoBrancheEnum,
): BrancheRequestDtoBrancheEnum {
  switch (value) {
    case BrancheDtoBrancheEnum.ADMINISTRATIVE:
      return BrancheRequestDtoBrancheEnum.ADMINISTRATIVE;
    case BrancheDtoBrancheEnum.INERTE:
      return BrancheRequestDtoBrancheEnum.INERTE;
    case BrancheDtoBrancheEnum.MAITRE_LIEU:
      return BrancheRequestDtoBrancheEnum.MAITRE_LIEU;
    case BrancheDtoBrancheEnum.NORMALE:
      return BrancheRequestDtoBrancheEnum.NORMALE;
    case BrancheDtoBrancheEnum.VOL:
      return BrancheRequestDtoBrancheEnum.VOL;
    default:
      throw new ShouldNotHappen(value);
  }
}
